import React from 'react';
import { connect } from 'react-redux';
import { Control, Fieldset, actions } from 'react-redux-form';
import {
  enumEmploymentStatus,
  enumOccupationType,
  PLACEHOLDER_OPT,
  investmentInfoPath,
  folioAllowedSpecialChars,
} from './Schemas/baseRrf';
import Select from './Controls/Select';
import InputField from './Controls/Field';
import Address from './Address';
import {
  validateAddress } from './Validators';

const getFields = (showAdditional, dispatch, employPath) => ([
  {
    model: '.employmentStatus',
    RRFComp: Control,
    control: {
      onChange: () => dispatch(actions.reset(`${investmentInfoPath}${employPath}`)),
      component: Select,
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select your Employment Status.',
      },
    },
  },
  {
    model: '.occupationType',
    RRFComp: Control,
    control: {
      component: Select,
      errors: {
        required: val => showAdditional && (!val || !val.length || val === PLACEHOLDER_OPT),
      },
    },
    error: {
      messages: {
        required: 'Please select your Occupation Type.',
      },
    },
  },
  {
    model: '.employerName',
    RRFComp: Control.text,
    control: {
      placeholder: 'Employer Name',
      maxLength: 45,
      errors: {
        required: val => !val || !val.length,
        employerName: val => val && !validateAddress(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide the name of your employer.',
        employerName: val => `The following characters are not allowed: ${
          val.replace(folioAllowedSpecialChars, '').split('')
            .filter((item, pos, self) => self.indexOf(item) === pos)
            .join('')}`,
      },
    },
  },
]);

const EmploymentInfo = ({ employPath, showAdditional, dispatch }) => {
  const fields = getFields(showAdditional, dispatch, employPath);
  return (
    <Fieldset model={employPath}>
      <InputField key={fields[0].model} fieldProps={fields[0]}>
        {Object.keys(enumEmploymentStatus).map(key => (
            (key === PLACEHOLDER_OPT) ?
              <option key={key} disabled value={key}>{enumEmploymentStatus[key]}</option>
            : <option key={key} value={key}>{enumEmploymentStatus[key]}</option>
          ))}
      </InputField>
      {showAdditional ?
        <div>
          <InputField key={fields[1].model} fieldProps={fields[1]}>
            {Object.keys(enumOccupationType).map(key => (
                (key === PLACEHOLDER_OPT) ?
                  <option key={key} disabled value={key}>{enumOccupationType[key]}</option>
                : <option key={key} value={key}>{enumOccupationType[key]}</option>
              ))}
          </InputField>
          <InputField key={fields[2].model} fieldProps={fields[2]} />
          <Address addrPath=".employerAddress" required={showAdditional} />
        </div>
      : null}
    </Fieldset>
  );
};

export default connect(null, null)(EmploymentInfo);




// WEBPACK FOOTER //
// ./src/components/Forms/EmploymentInfo.js